// src/newDashboard/admin/AdminLayout.jsx
//
// Admin Mode frame: purple banner, a button for each admin page, then the
// page. The buttons wrap onto more lines on a phone (see AdminShell.css).

import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import "./AdminShell.css";

const TABS = [
  { label: "Overview", path: "/admin" },
  { label: "Bars to call", path: "/admin/outreach" },
  { label: "Reports", path: "/admin/reports" },
  { label: "Claimed bars", path: "/admin/claimed" },
  { label: "Demo bar", path: "/admin/demo" },
  { label: "Add a Bar", path: "/admin/add-bar" },
  { label: "Gambling States", path: "/admin/gambling-states" },
  { label: "Pills by state", path: "/admin/pills" },
  { label: "Load Bars", path: "/admin/import" },
  { label: "National bars", path: "/admin/national" },
  { label: "Sign-ups", path: "/admin/signups" },
  { label: "Posts", path: "/admin/posts" },
];

export default function AdminLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.length > 1 ? location.pathname.replace(/\/+$/, "") : location.pathname;

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <div className="ad-shell">
      <div className="ad-banner">
        <span className="ad-badge">ADMIN MODE</span>
        <span className="ad-note">You're managing Bar Fun Finder's backend — regular bar owners never see this.</span>
        <button type="button" className="ad-logout" onClick={handleLogout}>Log Out</button>
      </div>

      <nav className="ad-tabs" aria-label="Admin pages">
        {TABS.map((tab) => {
          const isActive = path === tab.path;
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`ad-tab ${isActive ? "active" : ""}`}
              aria-current={isActive ? "page" : undefined}
            >
              {tab.label}
            </Link>
          );
        })}
      </nav>

      <div className="ad-content">{children}</div>
    </div>
  );
}
